"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IndexedTracker = /** @class */ (function () {
    function IndexedTracker() {
    }
    return IndexedTracker;
}());
exports.IndexedTracker = IndexedTracker;
